module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("PCS 01 API Response")]), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Interface Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "interfaceName",
      "name": "interfaceName"
    },
    model: {
      value: (_vm.interfaceName),
      callback: function($$v) {
        _vm.interfaceName = $$v
      },
      expression: "interfaceName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("IGM Number (2272354)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "igmNumber",
      "name": "igmNumber"
    },
    model: {
      value: (_vm.igmNumber),
      callback: function($$v) {
        _vm.igmNumber = $$v
      },
      expression: "igmNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.interfaceName && _vm.igmNumber) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.getAllPCS01Func()
      }
    }
  }, [_vm._v("Fetch")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "12"
    }
  }, [(_vm.getAllPcs01 && _vm.getAllPcs01.length > 0 && _vm.headers.length > 0) ? _c('div', {
    staticClass: "shipper-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "purple-gradient"
  }, [_vm._v("SN")]), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      key: index,
      staticClass: "purple-gradient"
    }, [_vm._v("\n                    " + _vm._s(_vm.formatHeader(header)) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAllPcs01), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "fade-in"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
      return _c('td', {
        key: index
      }, [_vm._v("\n                    " + _vm._s(item[header]) + "\n                  ")])
    })], 2)
  }))])]) : _vm._e()])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72c1d2ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/PCS01_ResponseDisplay.vue
// module id = 2745
// module chunks = 0